import { useEffect } from "react";
import * as signalR from "@microsoft/signalr";
import axios from "axios";
import SessionConstants from "../../config/SessionConstants"; 
import APIUtils from "../../utils/APIUtils";

export function useSignalRStatusNotification(onStatusUpdate) {
  useEffect(() => {
    let connection;
    async function startSignalR() {
      try {
        console.log("useSignalRStatusNotification");
        // 1. Get connection info from negotiate endpoint, include UserId in payload
        const negotiateData = await APIUtils.signalRnegotiate();

        // 2. Connect to SignalR hub
        console.log("Connecting to SignalR hub");
        connection = new signalR.HubConnectionBuilder()
          .withUrl(negotiateData.Url, { accessTokenFactory: () => negotiateData.AccessToken })
          .withAutomaticReconnect()
          .build();

        // 3. Listen for statusUpdate messages
        console.log("Setting up SignalR listener for statusUpdate");
        connection.on("statusUpdate", (message) => {
          onStatusUpdate(message);
        });

        // Error handling for connection close
        connection.onclose((error) => {
          console.warn("SignalR connection closed", error);
        });

        // Error handling for reconnect attempts
        connection.onreconnecting((error) => {
          console.warn("SignalR reconnecting...", error);
        });

        connection.onreconnected((connectionId) => {
          console.log("SignalR reconnected", connectionId);
        });

        await connection.start();
        console.log("SignalR connected");
      } catch (err) {
        console.log("SignalR connection timeout:", err);
      }
    }

    startSignalR();

    return () => {
      if (connection) connection.stop();
    };
  }, [onStatusUpdate]);
}
